import { useEffect } from "react";

/**
 * Hard-disable horizontal scrolling on mount and restore on unmount.
 */
export function useDocumentScrollLock() {
  useEffect(() => {
    const prevHtml = document.documentElement.style.overflowX;
    const prevBody = document.body.style.overflowX;

    document.documentElement.style.overflowX = "hidden";
    document.body.style.overflowX = "hidden";

    return () => {
      document.documentElement.style.overflowX = prevHtml;
      document.body.style.overflowX = prevBody;
    };
  }, []);
}
